var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"copy"}},[_vm._v("Copyright © 2018-2020 岐黄在线（上海）智能科技有限公司 . All rights reserved")])}
var staticRenderFns = []

export { render, staticRenderFns }